import styled from "styled-components";

const SearchBarContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
`;

export default SearchBarContainer;
